import { IntlShape } from 'react-intl';

export const formatDuration = (duration: number, intl: IntlShape): string => {
  /* Converting the duration from minutes to hours. */
  const hours = Math.floor(duration / 60);
  /* Getting the remainder of the division of the duration by 60. */
  const minutes = duration % 60;

  const hoursFormat = hours
    ? intl.formatMessage(
        { id: 'movie_period_hours' },
        {
          h: hours,
        }
      )
    : '';

  const minsFormat = minutes
    ? intl.formatMessage({ id: 'movie_period_minutes' }, { m: minutes })
    : '';

  return [hoursFormat, minsFormat].filter(w => !!w).join(' ');
};
